import { useEffect } from 'react';

/**
 * useNoIndex — marks the current page as non-indexable for search engines.
 * Sets <meta name="robots" content="noindex, nofollow"> on mount and restores
 * the default indexable value on unmount (public pages re-assert index via SEO.jsx).
 *
 * Use on private / transactional pages: auth, dashboard, mentor panel,
 * onboarding, admin and payment callback screens.
 */
export function useNoIndex() {
  useEffect(() => {
    let meta = document.head.querySelector('meta[name="robots"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    const prev = meta.getAttribute('content');
    meta.setAttribute('content', 'noindex, nofollow');

    return () => {
      if (created) {
        meta.setAttribute('content', 'index, follow, max-image-preview:large');
      } else {
        meta.setAttribute('content', prev || 'index, follow, max-image-preview:large');
      }
    };
  }, []);
}

export default useNoIndex;
